export const toUnixTimestamp = (timestamp: number) =>
  Math.floor(timestamp / 1000);
